export default __webpack_public_path__ + "static/media/sphere-yellow.4e7fc363.png";